import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";
import { fontSizes, fontWeights, typographyMixin } from "../../../design-system/tokens/typography";

/** F05 breadcrumb: inline row, gap 8. */
export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

const crumb = `
  font-size: ${fontSizes[13]};
  white-space: nowrap;
`;

/** "Data stories": 13px, medium emphasis; a button when it navigates. */
export const HomeCrumb = styled.button`
  ${typographyMixin("body", 4)}
  ${crumb}
  padding: 0;
  border: 0;
  background: none;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  &:hover { color: ${rawColors.text.highEmphasis}; }
`;

export const HomeText = styled.span`
  ${typographyMixin("body", 4)}
  ${crumb}
  color: ${rawColors.text.mediumEmphasis};
`;

/** GAP: the design's #A39CB0 separator has no token; low emphasis is the nearest. */
export const Separator = styled.span`
  ${crumb}
  color: ${rawColors.text.lowEmphasis};
`;

/** Story title: 13px, weight 600, high emphasis. */
export const Title = styled.span`
  ${typographyMixin("body", 2)}
  ${crumb}
  font-weight: ${fontWeights.semibold};
  color: ${rawColors.text.highEmphasis};
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** The title as a click-to-rename control: looks like the title, no chrome. */
export const TitleButton = styled.button`
  ${typographyMixin("body", 2)}
  ${crumb}
  font-weight: ${fontWeights.semibold};
  color: ${rawColors.text.highEmphasis};
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
  cursor: text;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const statusChip = `
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  height: ${spacing[5]};
  min-height: 1.375rem;
  padding: 0 ${spacing[2]};
  border: 0;
  border-radius: ${borderRadius.md};
  background: ${rawColors.grey[100]};
  color: ${rawColors.text.highEmphasis};
  white-space: nowrap;
  flex-shrink: 0;
`;

/** Read-only status chip: 22px tall, radius 6, grey-100 fill, 11/700. */
export const StatusPill = styled.span`
  ${statusChip}
  ${typographyMixin("caption", 1)}
  font-size: ${fontSizes[11]};
  cursor: default;
`;

/** Status menu trigger: the same chip as a button, with a 12px chevron. */
export const StatusChipButton = styled.button`
  ${statusChip}
  ${typographyMixin("caption", 1)}
  font-size: ${fontSizes[11]};
  cursor: pointer;

  &:hover { background: ${rawColors.grey[200]}; }
  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
  }
`;
